    <template >
  <div v-role="roles">

  <div>
  <div class="formPosition">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  
  <template >

    <v-form ref="form" v-model="formValid" lazy-validation>
      <v-container class="text-md-left" >
        <v-row no-gutters >
          <v-col md="12">
            <v-card>
              <v-list flat>
                <v-header>
                
                     <v-row>
                      <v-col md="12">
                          <v-row>
                            <v-col md="6">
                                <v-card-title>Lançamento de notas do Iº Trimestre</v-card-title>
                            </v-col>
                            <v-col md="5">
                              <div :style="estiloPauta"
                                v-if="$store.state.hasMessage"
                                :class="$store.state.classMessage"
                              >{{$store.state.textMessage}}</div>
                            </v-col>
                            <v-col md="1">
                              <v-btn fab small style="background-color:#006699;" to="menu">
                                <v-icon color="white" small>arrow_back</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-card-text>
                            <v-row>
                            <v-col md="4">
                              <v-combobox 
                                :items="classes"
                                v-model="classeSelected"
                                item-text="descricao"
                                label="Selecionar a classe"
                                return-object
                                @change="filtrarTurmas()"
                                placeholder="Selecione a classe">
                              </v-combobox>
                            </v-col>
                            <v-col md="4">
                              <v-combobox 
                              :items="turmasFilter"
                              v-model="turmaSelected"
                              item-text="descricao"
                              label="Selecionar a Turma" 
                              @change="findDisciplinaInProfDisc()"
                              placeholder="Selecione a turma">
                              </v-combobox>
                            </v-col>
                            <v-col md="4">
                              <v-combobox 
                                :items="disciplinas"
                                v-model="disciplinaSelected"
                                @change="pautaByTurma()"
                                item-text="descricao"
                                label="Selecionar a Disciplina" 
                                placeholder="Selecione a disciplina"
                                 return-object
                                >
                              </v-combobox>
                              </v-col>
                            </v-row>
                          </v-card-text>
                       </v-col>   
                     </v-row>

                </v-header>

                <v-list-item-group v-model="item" color="primary" style="width:100%">
                  <!--  1 e 2 trimestre  header -->
                  <v-row style="background-color:#ccc;margin-left:0px;width:100%" v-if="listEstudantfromPauta.length">
                     <v-col cols="12" sm="12" md="1"></v-col>
                    <v-col cols="12" sm="12" md="1">N.</v-col>
                    <v-col cols="12" sm="12" md="2">Nome</v-col>

                    <v-col cols="12" sm="12" md="1">Mac</v-col>

                    <v-col cols="12" sm="12" md="1">P1</v-col>

                    <v-col cols="12" sm="12" md="1">P2</v-col>

                    <v-col cols="12" sm="12" md="1">MD</v-col>

                    <v-col cols="12" sm="12" md="1">Action</v-col>
                    <v-col cols="12" sm="12" md="1">Autor</v-col>
                  </v-row>

                  <hr v-if="listEstudantfromPauta.length"><br>

                  <v-list-item v-for="(item, i) in listEstudantfromPauta" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <!-- body 1  trimestre -->

                 <v-row   class="bodyLancamentoNotas">
                   <v-col cols="12" sm="12" md="1">
                    <img src="img/default-avatar.png" alt="avatar" width="30px;" />
                   </v-col>

                      <v-col cols="12" sm="12" md="1">{{i+1}}.</v-col>

                      <v-col cols="12" sm="12" md="2">
                        <v-list-item-title v-text="item.nome"></v-list-item-title>
                      </v-col>

                      <v-col cols="12" sm="12" md="1">
                        <p v-if="editedpk!==item.pkpauta" class="text-lowercase">{{item.p1_notaMac}}</p>
                        <v-text-field :rules="notaRules"
                          v-if="editedpk===item.pkpauta"
                          v-model="editedItem.p1_notaMac"
                          single-line
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="1">
                        <p v-if="editedpk!==item.pkpauta" class="text-lowercase">{{item.p1_nota}}</p>
                        <v-text-field :rules="notaRules"
                          v-if="editedpk===item.pkpauta"
                          v-model="editedItem.p1_nota"
                          single-line
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="1">
                        <p v-if="editedpk!==item.pkpauta" class="text-lowercase">{{item.p1_nota2}}</p>
                        <v-text-field :rules="notaRules"
                          v-if="editedpk===item.pkpauta"
                          v-model="editedItem.p1_nota2"
                          single-line
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="1">
                        <p class="text-lowercase">{{item.p1_MD}}</p>
                      </v-col>
                      <v-col cols="12" sm="12" md="1">
                        <!--=========
                          *
                          *Vai mostrar esse botão( Editar a nota ou lançar ) caso as notas do estudante não forem transportadas, se o estudante não for desistente ou ter a matricula anulada e se o usuário não seja administrador
                        <-->
                        <v-btn
                          color="red"
                          fab
                          x-small
                          dark
                          :disabled="btn_activacao1"
                          v-if="pautaBloqueada"
                          class="mr-2"
                          text
                        >
                          <v-icon>block</v-icon>
                        </v-btn>
                        <v-btn
                          color="secondary"
                          fab
                          x-small
                          dark
                          :disabled="btn_activacao1"
                          v-if="!pautaBloqueada && editedpk!==item.pkpauta && !item.notas_transportadas && (parseInt(item.desistente) !== 6 && parseInt(item.desistente) !== 7)"
                          class="mr-2"
                          @click="bt_edit(item)"
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>

                        <p  v-if="parseInt(item.desistente) === 6">Desistente</p>
                        <p  v-if="parseInt(item.desistente) === 7">Matricula Cancelada</p>
                        <v-btn
                          color="primary"
                          fab
                          x-small
                          dark
                          v-if="editedpk===item.pkpauta"
                          @click="bt_save(editedItem)"
                        >
                          <v-icon>save_alt</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="12" sm="12" md="1">
                        <span style="font-size:8px;">{{item.autor}}--{{item.data_2}}</span>
                      </v-col>
                    </v-row>
                  </v-list-item>

                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      </v-form >
    </template>
  </div>
  </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    formValid: true,
    estiloPauta: 'position:fixed;background-color:green;color:white;',
    on: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 20) || 'nota invalida',
      v => !isNaN(v) || 'not number ',

      v => (v.length <= 2) || 'valor inválido'

    ],
    text: '',
    editedpk: 0,
    profediscinas: [],
    diasDesbloqueio: 
    [
      {id:1, descricao:'1 dia'},
      {id:2, descricao:'2 dias'},
      {id:3, descricao:'3 dias'},
      {id:4, descricao:'4 dias'},
      {id:5, descricao:'5 dias'}
    ],
    classes:[
      {id:1,descricao:'10ª classe'},
      {id:2,descricao:'11ª classe'},
      {id:3,descricao:'12ª classe'},
      {id:4,descricao:'13ª classe'}
    ],
    pautaBloqueada: false,
    objBloqueioPauta: null,
    turmaSelected: null,
    overlay: false,
    role_usuario: '',
    disciplinas: [],
    _classe: '',
    Professor: '',
    dialog: false,
    dialogoDisabilita: false,
    progresso_2: false,
    progresso_3: false,
    lancamentoSelected: 1,
    progresso: true,
    disciplinaSelected: null,
    idanoacademico: 0,
    offset: true,
    descricao_Prof: '',
    tumaSelect: '',
    iddisciplina: 0,
    btn_description: '',
    publicar_status: false,
    idturma: 0,
    closeOnClick: true,
    item: 1,
    listaPautasBloquadas: [],
    btn_activacao1: false,
    btn_activacao2: false,
    btn_activacao3: false,
    listaDeClassesPorLancarNotas: [],
    listEstudantfromPauta: [],
    roles: 'prof',
    classeSelected:null,
    items:
    [
      { id: 1, descricao: 'Nota por nota' },
      { id: 2, descricao: 'Todas as notas' }
    ],
    editedIndex: -1,
    editedItem: {
      dayValidity: null,
      pkpauta: 0,
      p1_notaMac: 0,
      p1_nota: 0,
      p1_nota2: 0,
      p1_MD: 0,
      p2_notaMac: 0,
      p2_nota: 0,
      p2_nota2: 0,
      p2_MD: 0,
      p3_notaMac: 0,
      p3_nota: 0,
      p3_MD: 0,
      pg: 0,
      ca: 0,
      mfd: 0
    }
  }),
  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    role () {
      return ls.get('role')
    }
  },

  watch: {

    listaDeClassesPorLancarNotas () {
      this.$store.state.isloading = false
    }
  },
  created () {
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    // this.CarregActividades()
    this.turmaFindWithEstudanteCount('all')
    this.initprofdisc()
    this.role_usuario = ls.get('role')
  },

  methods: {
    classe (idanoacademico) {
      if (idanoacademico === 1) {
        this._classe = '10ª Classe'
      }
      if (idanoacademico === 2) {
        this._classe = '11ª Classe'
      }
      if (idanoacademico === 3) {
        this._classe = '12ª Classe'
      }
      if (idanoacademico === 4) {
        this._classe = '13ª Classe'
      }

      this.idanoacademico = idanoacademico
      
    },
    loadprogressbar () {
      this.$store.state.isloading = true
    },

    bt_edit (item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedpk = item.pkpauta
      this.editedItem.trimestre = this.$store.state.idperfilpauta
      this.editedItem.pkpauta = item.pkpauta

      setTimeout(() => {}, 1000)
    },
    MostrarDialogo () {
      this.dialog = true
    },

    MostrarDialogoDisabilitar () {
      this.dialogoDisabilita = true
    },
    bt_save (editedItem) {
      // this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      editedItem.p1_MD = Math.round(
        (Number(editedItem.p1_notaMac) +
          Number(editedItem.p1_nota) +
          Number(editedItem.p1_nota2)) /
          3
      )
      editedItem.p2_MD = Math.round(
        (Number(editedItem.p2_notaMac) +
          Number(editedItem.p2_nota) +
          Number(editedItem.p2_nota2)) /
          3
      )
      editedItem.p3_MD = Math.round(
        (Number(editedItem.p3_notaMac) +
          Number(editedItem.p3_nota)) /
          2
      )
      if (this.formValid) {
        this.save(editedItem)
        

        this.editedpk = 0
      }
      setTimeout(() => {}, 1000)
    },
    backTodisciplinList () {
      this.listEstudantfromPauta = []
    },
    backToTurmaList () {
      this.disciplinas = []
    },

    filtrarTurmas () {
      this.overlay = true
      this.turmasFilter = []
      this.disciplinas = []
      this.listEstudantfromPauta = []
      this.disciplinaSelected = null
      this.turmaSelected = null
      this.turmasFilter = this.listaDeClassesPorLancarNotas.filter(t=>t.idAno_Academico=== this.classeSelected.id)
      this.overlay = false
    },

    async turmaFindWithEstudanteCount (idclasse) {
      this.progresso = true
      try {
        this.progresso = true
        this.listaDeClassesPorLancarNotas = await axios
          .get('/turmaFindWithEstudanteCount/' + 'all') // idclasse JyUn JQ==
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        // this.isLoading = false
        this.progresso = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
      this.listEstudantfromPauta = []
    },
    async save (editedItem) {

      if( this.role === 'ROLE_ADM' ){
        this.estiloPauta = 'position:fixed;background-color:red;color:white;'
        this.$store.dispatch('textMessage', {msg: 'Não é permitido ao administrador Lançar Notas ou altera-las.',classMessage: 'msgError',timeout: 8000})
     }else{
          var params = {
          p1_notaMac: editedItem.p1_notaMac,
          p1_nota: editedItem.p1_nota,
          p1_nota2: editedItem.p1_nota2,
          p1_MD: editedItem.p1_MD,
          p2_notaMac: editedItem.p2_notaMac,
          p2_nota: editedItem.p2_nota,
          p2_nota2: editedItem.p2_nota2,
          p2_MD: editedItem.p2_MD,
          p3_notaMac: editedItem.p3_notaMac,
          p3_nota: editedItem.p3_nota,
          p3_MD: editedItem.p3_MD,
          pg: editedItem.pg,
          ca: editedItem.ca,
          mfd: editedItem.mfd,
          autor: ls.get('nomeUsuario'),
          pkpauta: editedItem.pkpauta,
          trimestre: 1
        }

        try {
          let msg = await axios.post('/lancarNota', params).then(res => res.data)
          // this.text = msg[1].insertId
          this.text = msg

          try {
            if (msg.affectedRows >= 1) {
              this.text = msg.affectedRows + ' gravado(s) com sucesso'
              this.$store.dispatch('textMessage', {
                msg: this.text,
                classMessage: 'msgSucess',
                timeout: 2000
              })
              Object.assign(this.listEstudantfromPauta[this.editedIndex], params)
            }
          } catch (error) {

          }
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } catch (error) {}

          if (this.editedIndex > -1) {
            //  Object.assign(this.estudantes[this.editedIndex], this.editedItem)
          } else {
            this.estudantes.push(this.editedItem)
          }
          //  this.close();
        } catch (error) {
          this.isLoading = false

          this.text = error.message
          this.$store.dispatch('textMessage', {
            msg: this.text + ' - ' + error,
            classMessage: 'msgError',
            timeout: 8000
          })
        } finally {
        }
     }
    },

     
   

    async  criarExcecaoDeDesbloqueiodePauta(){

        let params = 
          {
              id: null,
              disciplina: this.$store.state.objDisciplina,
              turma:this.$store.state.objturma,
              autor: ls.get('nomeUsuario'),
              dayValidity: this.editedItem.dayValidity,
              trimestre:1
          }

       try {
         let result = await axios
          .post('/exceptionMiniPautaInsertOrUpdate',params)
          .then(res => res.data)
        if(result.affectedRows >= 1){
            this.dialogoDisabilita = false
            this.pautaBloqueada = false
            this.$store.dispatch('textMessage', {msg: 'Pauta desbloqueada com sucesso',classMessage: 'msgError',timeout: 8000})
        }
       } catch (error) {
         this.estiloPauta = 'position:fixed;background-color:red;color:white;'
         this.$store.dispatch('textMessage', {msg: 'Ocorreu um erro ao tentar efectuar a operação',classMessage: 'msgError',timeout: 8000})
      }

    },

    async pautaByTurma () {
      // carrega turma apartir de bauta  Turma
      let obj = this.disciplinaSelected
      this.$store.state.disciplina = obj.iddisciplina
      this.$store.state.objDisciplina = obj
      const payload =
        '{"iddisciplina":"' +
        obj.iddisciplina +
        '" , "pkturma":"' +
        obj.pkturma +
        '", "i_id":"' +
        ls.get('i_id') +
        '"  }'

      try {
        this.progresso_3 = true
        this.listEstudantfromPauta = await axios

          .get('/listEstudantfromPauta/' + payload)
          .then(res => res.data)

        this.progresso_3 = false
        this.MostraProfessor()
        this.VerificaExcecaoBloqueioPauta().then((res)=>{
          /**
           * Verifica se a disciplina da turma selecionada e do trimestre foi adicionada no desbloqueio excepcional
           */
          if(!res.length)
            this.CarregaPautas()
        }).catch(error=>{
          this.$store.dispatch('textMessage', {msg: 'Ocorreu um erro durante a verificação,por favor tente novamente',classMessage: 'msgError',timeout: 3000})
          this.CarregaPautas()
        })
      } catch (error) {
        // this.isLoading = false
        this.progresso_3 = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async initprofdisc (search) {
      try {
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }
        this.profediscinas = await axios
          .get('/professordiscFindAll/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async PublicarPauta () {
      const valores =
          {

            disciplina: this.$store.state.objDisciplina,
            curso: this.$store.state.objturma,
            trimestre:  1,
            autor:  ls.get('nomeUsuario'),
            classe: this.editedItem.classe,
            bloqueada:1


            // turma: this.$store.state.objturma,
            // disciplina: this.$store.state.disciplina,
            // trimestre: this.$store.state.lancarNotaDe,
            // bloquear: 1,
            // publicar: 1,
            // idControlopauta: 0,
            // idCurso: this.$store.state.objturma
          }

      // Consumindo a API
      try {
        // eslint-disable-next-line no-unused-vars
        let valor = await axios

          .post('/bloquearPauta', valores)
          .then(res => res.data)
        // eslint-disable-next-line no-unused-vars
        let text = 'Pauta publicada com sucesso'
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
        this.dialog = false

        this.$store.state.bloqueado.push(valores)
        // this.$store.state.bloqueado = []
        // CarregaPauta
        this.verificaPautas()
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },

    MostraProfessor () {
      let valor = this.profediscinas.filter(d => d.iddisciplina === this.$store.state.disciplina)
      if (valor.length) {
        this.Professor = valor[0].nome
        this.descricao_Prof = 'disciplina atrbuida ao Professor'
      } else {
        this.Professor = 'Sem Professor Associado'
        this.descricao_Prof = ''
      }
    },

    irParaValiacao (item) {
      this.$store.state.objPauta = item
      this.$store.state.rotas = 'lancar-trimestre-um'
      this.$router.push('avalicacao-comportamento')
    },

    async CarregaPautas () {
      this.overlay = true
      try {
        let params =
        {
          disciplina: this.$store.state.disciplina,
          turma: this.$store.state.objturma,
          trimestre: 1
        }

          let results = await axios
          .post('/ListarPautaBloqueada', params)
          .then(res => res.data)
          this.overlay = false
        if(results.length){
           this.objBloqueioPauta = results[0]
           this.pautaBloqueada = true;
           this.overlay = false
        }
        else
          this.pautaBloqueada = false
      } catch (error) {
        this.overlay = false
        this.$store.dispatch('textMessage', {msg: error,classMessage: 'msgError',timeout: 3000})
      }
      finally{
        this.overlay = false
      }
    },

     async VerificaExcecaoBloqueioPauta () {
      this.overlay = true
      try {
        let params =
        {
          disciplina: this.$store.state.objDisciplina,
          turma: this.$store.state.objturma,
          trimestre: 1
        }

          return  await axios
          .post('/ObterExceptionMinipauta', params)
          .then(res => res.data)
        
      } catch (error) {
        this.overlay = false
        this.$store.dispatch('textMessage', {msg: error,classMessage: 'msgError',timeout: 3000})
      }
      finally{
        this.overlay = false
      }
    },

    TrimestreToInteger(value){
      switch (value) {
        case "1º Trimestre":
          return 1;
          case "2º Trimestre":
          return 2;
          case "3º Trimestre":
          return 4;
      
        default:
          break;
      }
    },

    HabilitaBotoes (valor) {
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '1º Trimestre')) {
        this.btn_activacao1 = valor
      }
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '2º Trimestre')) {
        this.btn_activacao2 = valor
      }
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '3º Trimestre')) {
        this.btn_activacao3 = valor
      }
    },



    MudarFormaLancamento () {

    },

    verificaPautas () {
      if (this.listaPautasBloquadas.length) {
        this.HabilitaBotoes(true)

        this.$store.state.Controlopauta = this.listaPautasBloquadas[0].idControlopauta
        if (ls.get('role') === 'ROLE_PROF') {
          this.publicar_status = true
          this.btn_description = 'Mini Pauta Bloqueada'
        } else {
          this.publicar_status = true
          this.HabilitaBotoes(false)
          this.btn_description = 'Mini Pauta Bloqueada'
        }
      } else {
        this.publicar_status = false
        this.btn_description = 'Bloquear'
        this.HabilitaBotoes(false)
      }
    },

    async findDisciplinaInProfDisc () {
        this.overlay = true
        this.disciplinas = []
        this.listEstudantfromPauta = []
        this.disciplinaSelected = null
        let obj = this.turmaSelected
        this.disciplinas = []
        this.$store.state.turma = obj.descricao
        this.$store.state.objturma = obj
        try {
          this.progresso_2 = true
          this.disciplinas = await axios

            .get('/findDisciplinaInProfDisc/' + obj.pkTurma)
            .then(res => res.data)
          this.progresso_2 = false
          this.overlay = false
        } catch (error) {
          // this.isLoading = false
          this.progresso_2 = false
          this.overlay = false
          // this.text = error
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }

   },


    irAvaliarComportamento () {
      this.$store.state.rotas = 'lancar-trimestre-um'
      this.$store.state.Pautas = this.listEstudantfromPauta
      this.$router.push('comportamento')
    }
  }
}
</script>
